import { NoticeInfoMapper } from "@/data/mapper/notice/notice-info-mapper";
import { AddNoticePayload } from "@/data/payload/notice/add-notice-payload";
import { DeleteNoticePayload } from "@/data/payload/notice/delete-notice-payload";
import { GetNoticeIdPayload } from "@/data/payload/notice/get-notice-id-payload";
import { UpdateNoticePayload } from "@/data/payload/notice/update-notice-payload";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { NoticeSource } from "@/data/source/notice-source";
import { NoticeInfoEntity } from "@/domain/entity/notice/notice-info-entity";
import { NoticeRepository } from "@/domain/repository/notice-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class NoticeRepositoryImpl implements NoticeRepository {
  constructor(private readonly noticeSource: NoticeSource) {}

  async fetchNoticeList(): Promise<SATResult<NoticeInfoEntity[], SATError>> {
    const result = await this.noticeSource.getNoticesList();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      NoticeInfoMapper.toEntityList,
      "NoticeRepositoryImpl::fetchNoticeList"
    );
  }

  async fetchNoticeDetail(
    payload: GetNoticeIdPayload
  ): Promise<SATResult<NoticeInfoEntity, SATError>> {
    const result = await this.noticeSource.getNoticeDetail(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      (dto) => NoticeInfoMapper.toEntity(dto, payload.id),
      "NoticeRepositoryImpl::fetchNoticeDetail"
    );
  }

  async addNotice(payload: AddNoticePayload): Promise<SATResult<void, SATError>> {
    const result = await this.noticeSource.addNotice(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async updateNotice(
    noticeUuid: string,
    payload: UpdateNoticePayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.noticeSource.updateNotice(noticeUuid, payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async updateNoticeByUuid(
    noticeUuid: string,
    payload: UpdateNoticePayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.noticeSource.updateNoticeByUuid(noticeUuid, payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deleteNoticeByUuid(
    noticeUuid: string,
    payload: DeleteNoticePayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.noticeSource.updateNoticeByUuid(noticeUuid, payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
